import './../../css/style.css'

function FooterInfo(){
    return(
        <>
        <p className='info'>
            *Importante: la presente no es una solicitud de apertura de Cuenta y/o de Tarjeta de Débito y no constituye obligación para el Banco de otorgar dichos productos. La solicitud de productos y servicios, así como la aceptación de sus términos y condiciones, será acordada con cada cliente, previa suscripción de la documentación correspondiente. El otorgamiento de producto o servicio por parte del Banco estará sujeto al estudio del caso concreto.
        </p>
        <p className='info'>
            En la siguiente pantalla podrá seleccionar una sucursal del Banco donde continuar el trámite y retirar su tarjeta de débito. Recuerde concurrir transcurridas 72 horas hábiles con su cédula de identidad, constancia de domicilio y comprobante de ingresos utilizado en el registro.
        </p>
    </>
    );    
}

export { FooterInfo }